export function CorehrSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/corehr.svg'"></ng-include>`
    }
}